import { Collapse, Grid, TextField, Typography } from "@mui/material";
import { LABEL_WIDTH } from "../constants";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { Fragment } from "react";

type Props = {
  index: number;
  open: boolean;
  margin?: boolean;
};

const SalaryIncreaseConfigFields = ({ index, open, margin }: Props) => {
  const configFields = [
    { label: "Muuta palkka", name: "changeSalary" },
    { label: "Korotus-%", name: "increasePercentage" },
    { label: "Korotus-€", name: "increaseAmount" },
  ];

  const { control } = useFormContext();

  const watchedFields = useWatch({
    control,
    name: `salaryComponents[${index}]`,
  });

  const isDisabled = (currentFieldName: string) => {
    if (!watchedFields) return false;
    // if other field than currentFieldName has a value (not empty), disable current field
    return configFields.some(
      (field) =>
        field.name !== currentFieldName &&
        watchedFields[field.name] != null &&
        watchedFields[field.name] !== "",
    );
  };

  return (
    <Collapse in={open}>
      <Grid
        container
        item
        xs={12}
        alignItems="center"
        columnSpacing={2}
        mb={margin ? 3 : 0}
      >
        {configFields.map((configField) => (
          <Fragment key={configField.name}>
            <Grid
              item
              style={{
                width: LABEL_WIDTH,
                textAlign: "end",
              }}
            >
              <Typography variant="secondary">{configField.label}</Typography>
            </Grid>
            <Grid item xs>
              <Controller
                name={`salaryComponents[${index}].${configField.name}`}
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    disabled={isDisabled(configField.name)}
                    type="number"
                    fullWidth
                    size="small"
                    sx={{ maxWidth: "230px" }}
                  />
                )}
              />
            </Grid>
          </Fragment>
        ))}
      </Grid>
    </Collapse>
  );
};

export default SalaryIncreaseConfigFields;
